export const INVESTMENT_OPTIMIZATION_COMPARISON_VERSION = "1.0";

export const EMPTY_INVESTMENT_OPTIMIZATION_COMPARISON = Object.freeze({
  contractVersion: INVESTMENT_OPTIMIZATION_COMPARISON_VERSION,
  status: "UNAVAILABLE",
  currency: "EUR",
  currentPosition: null,
  economicOpportunity: null,
  executablePosition: null,
  opportunityGap: null,
  scenarioAttribution: [],
});
